import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  projectOverviewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    border: '1px solid rgba(30, 30, 30, 0.10)',
    borderRadius: '8px',
    height: '444px',
  },
  projectOverview: {
    display: 'flex',
    color: '#1E1E1E',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
  },
  overviewCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignSelf: 'stretch',
    // height: '84px',
    // width: '328px',
    padding: '20px 24px',
    border: '1px solid #E7E2F1',
    borderRadius: '8px',
    backgroundColor: 'rgba(30, 30, 30, 0.03)',
    '& .title': {
      height: '16px',
      alignSelf: 'stretch',
      color: 'rgba(30, 30, 30, 0.70)',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '16px',
    },
    '& .value': {
      textAlign: 'center',
      alignSelf: 'stretch',
      flex: '1 0 0',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '22px',
      color: '#1E1E1E',
    },
    '& .progress': {
      height: '8px',
    },
  },
  actions: {
    display: 'flex',
    gap: '16px',
    '& .btn': {
      fontSize: '14px',
      lineHeight: '16px',
      borderRadius: '8px',
      border: '1px solid #1E1E1E',
      width: '100%',
      height: '40px',
    },
    '& button.goToProject': {
      color: '#1E1E1E',
    },
    '& button.editProject': {
      backgroundColor: '#1E1E1E',
      color: '#FFF',
    },
  },
}));
